/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItemsGrid_similarItems$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainerNotListed_similarGridItems$ref: FragmentReference;
export type PdpRespContainerNotListed_similarGridItems = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +$fragmentRefs: PdpRespSimilarItemsGrid_similarItems$ref
    |}
  |}>,
  +$refType: PdpRespContainerNotListed_similarGridItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainerNotListed_similarGridItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "moreLikeThisEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsGrid_similarItems",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '91031b7cc47604623168a8c7da13c6cb';
module.exports = node;
